
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"24","viewBox":"0 0 32 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.695 11.654A8.64 8.64 0 0116 4.85a8.653 8.653 0 00-14 6.804 8.653 8.653 0 0014 6.803 8.64 8.64 0 01-3.305-6.803z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".8","d":"M16 4.849a8.64 8.64 0 00-3.305 6.803A8.64 8.64 0 0016 18.456a8.639 8.639 0 003.306-6.804 8.636 8.636 0 00-3.305-6.803z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".5","d":"M30 11.654a8.653 8.653 0 01-14.001 6.803 8.638 8.638 0 003.306-6.803 8.638 8.638 0 00-3.306-6.804 8.653 8.653 0 0114 6.804","fill":"#fff"}})])
          )
        }
      }
    